import {
  createLoader,
  createSerializer,
  parseAsStringLiteral,
} from "nuqs/server";

export const addDatasetParser = parseAsStringLiteral(["1"] as const);

const bigQuerySearchParams = {
  addDataset: addDatasetParser,
};

const loadBigQuerySearchParamsRecord = createLoader(bigQuerySearchParams);

/** Next.js が重複 key を配列化する既存挙動を保ち、単一値だけを読み込みます。 */
export async function loadBigQuerySearchParams(
  searchParams: Promise<Record<string, string | string[] | undefined>>,
) {
  const resolvedSearchParams = await searchParams;
  if (Array.isArray(resolvedSearchParams.addDataset)) {
    return { addDataset: null };
  }
  return loadBigQuerySearchParamsRecord(resolvedSearchParams);
}

export const serializeBigQuerySearchParams =
  createSerializer(bigQuerySearchParams);
